import { Box, CircularProgress } from '@mui/material'
import {
  Checkmark16Filled,
  Circle16Regular,
  Clock16Regular,
  ErrorCircle16Regular,
} from '@/components/Icon'

const TONE = {
  pending: 'var(--app-text-secondary)',
  running: 'var(--app-text-secondary)',
  waiting: 'var(--app-text-secondary)',
  error: 'var(--app-status-blocked-fg)',
  done: 'var(--app-status-done-fg)',
}

function Glyph({ status }) {
  if (status === 'waiting') return <Clock16Regular fontSize={14} />
  if (status === 'error') return <ErrorCircle16Regular fontSize={14} />
  if (status === 'done') return <Checkmark16Filled fontSize={14} />
  return <Circle16Regular fontSize={14} />
}

export default function StepIcon({ status, streaming = false }) {
  if (status === 'running' && streaming) return <CircularProgress size={12} thickness={5} />
  return (
    <Box component="span" sx={{ color: TONE[status] ?? TONE.done, display: 'flex' }}>
      <Glyph status={status} />
    </Box>
  )
}
